/**
 * @fileoverview Custom Clear Refinements Module for InstantSearch.js.
 * Implements a custom clear refinements connector and rendering function for InstantSearch.js.
 */

import {connectClearRefinements} from "instantsearch.js/es/connectors";

/**
 * Renders a custom clear refinements button.
 * This function is used as a connector for the clear refinements widget in InstantSearch.js.
 * It creates a button that allows users to clear all active refinements and update the UI accordingly.
 *
 * @param {Object} renderOptions - The options and utilities provided by InstantSearch.js for rendering the widget.
 * @param {boolean} isFirstRender - Indicates if this is the first render of the widget.
 */
const renderClearRefinements = (renderOptions, isFirstRender) => {
    const {refine, hasRefinements, widgetParams} = renderOptions;
    const {container, label, updatePreviousRefinementValue} = widgetParams;

    if (isFirstRender) {
        const button = document.createElement('button');
        button.classList.add('mr-12', 'pb-4', 'refinement-button-js');
        button.textContent = label;

        button.addEventListener('click', () => {
            refine();
            updatePreviousRefinementValue(null);
        });

        container.appendChild(button);
    }
    const button = document.querySelector('.refinement-button-js');

    if (!hasRefinements && button) {
        button.classList.add('border-b-4');
    } else {
        button.classList.remove('border-b-4');
    }
};

/**
 * Custom Clear Refinements Connector using InstantSearch.js's connectClearRefinements.
 * This creates a custom clear refinements widget for InstantSearch.js implementations.
 */
const customClearRefinements = connectClearRefinements(
    renderClearRefinements
);

/**
 * Clear Refinements Component function.
 * Initializes the custom clear refinements widget with specified options.
 *
 * @param {Object} data - Configuration data for the widget.
 * @returns {Function} A function that creates the custom clear refinements widget.
 */
export const clearRefinementsComponent = (data) =>
    customClearRefinements({
        container: document.querySelector(data["container"]),
        updatePreviousRefinementValue: data['updatePreviousRefinementValue'],
        label: data['label']
    });